import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

// Connects to data-controller="flatpickr"
export default class extends Controller {
  static targets = ["date"];
  static values = {
    minDate: String,
    maxDate: String,
    disabled: { type: Boolean, default: false },
  };

  connect() {
    this.datepicker();
  }

  datepicker() {
    if (this.hasDateTarget) {
      flatpickr(this.dateTarget, {
        locale: "ja",
        static: true,
        dateFormat: "Y/m/d",
        allowInput: true,
        minDate: this.minDateValue,
        maxDate: this.maxDateValue,
        clickOpens: false,
        disableMobile: true,
      });
      if (this.disabledValue) {
        this.dateTarget.disabled = true;
      }
    }
  }

  openDatepicker(event) {
    event.preventDefault();
    this.dateTarget._flatpickr.open();
  }
}
